import React, { useEffect, useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Radio,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import CloseIcon from '@mui/icons-material/Close';

const formatAmount = (item) => {
  if (item.amountInDocCurrency === null || item.amountInDocCurrency === undefined) return '-';
  return `${Number(item.amountInDocCurrency).toLocaleString()} ${item.currencyKey || ''}`.trim();
};

const formatDate = (value) => {
  if (!value) return '-';
  return new Date(`${value}T00:00:00`).toLocaleDateString('en-GB', {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
  });
};

const LineItemSelectionModal = ({ open, items, onBack, onClose, onNext }) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const summary = items[0] || {};

  useEffect(() => {
    setSelectedIndex(0);
  }, [items]);

  const handleNext = () => {
    onNext(items[selectedIndex]);
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{ sx: { borderRadius: '8px', margin: '24px', maxWidth: '916px', width: '100%' } }}
    >
      <DialogTitle sx={{ alignItems: 'center', color: '#2d2d2d', display: 'flex', fontSize: '20px', fontWeight: 700, justifyContent: 'space-between', lineHeight: 1.2, padding: '24px' }}>
        New Request
        <IconButton aria-label="Close" onClick={onClose} size="small" sx={{ color: '#616161', marginRight: '-8px' }}>
          <CloseIcon sx={{ fontSize: '26px' }} />
        </IconButton>
      </DialogTitle>
      <DialogContent sx={{ padding: '0 40px' }}>
        <Box sx={{ borderBottom: '1px solid #c7c7c7', display: 'grid', gap: '20px', gridTemplateColumns: 'repeat(3, 1fr)', paddingBottom: '18px' }}>
          <Box>
            <Typography sx={{ color: '#303030', fontSize: '14px', fontWeight: 700 }}>Company Code:</Typography>
            <Typography sx={{ color: '#303030', marginTop: '4px' }}>{summary.companyCode || '-'}</Typography>
          </Box>
          <Box>
            <Typography sx={{ color: '#303030', fontSize: '14px', fontWeight: 700 }}>Customer Number:</Typography>
            <Typography sx={{ color: '#303030', marginTop: '4px' }}>{summary.customerNo || '-'}</Typography>
          </Box>
          <Box>
            <Typography sx={{ color: '#303030', fontSize: '14px', fontWeight: 700 }}>Assignment Number:</Typography>
            <Typography sx={{ color: '#303030', marginTop: '4px' }}>{summary.assignmentNo || '-'}</Typography>
          </Box>
        </Box>

        <Box sx={{ border: '1px solid #c7c7c7', borderRadius: '10px', marginTop: '20px', overflow: 'hidden' }}>
          <Table size="small">
            <TableHead>
              <TableRow sx={{ height: '70px' }}>
                <TableCell sx={{ width: 56 }} />
                <TableCell align="center" sx={{ color: '#222222', fontSize: '14px', fontWeight: 700 }}>Amount in doc currency</TableCell>
                <TableCell align="center" sx={{ color: '#222222', fontSize: '14px', fontWeight: 700 }}>Reason Code</TableCell>
                <TableCell align="center" sx={{ color: '#222222', fontSize: '14px', fontWeight: 700 }}>Due date for net payment</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {items.map((item, index) => (
                <TableRow
                  key={`${item.accountingDocNo}-${item.noOfLineItemWithInAccDoc}-${index}`}
                  selected={selectedIndex === index}
                  onClick={() => setSelectedIndex(index)}
                  sx={{ cursor: 'pointer', height: '72px', '&.Mui-selected': { backgroundColor: '#f2f7f2' } }}
                >
                  <TableCell padding="checkbox">
                    <Radio
                      checked={selectedIndex === index}
                      onChange={() => setSelectedIndex(index)}
                      value={index}
                      inputProps={{ 'aria-label': `Select line item ${index + 1}` }}
                    />
                  </TableCell>
                  <TableCell align="center" sx={{ color: '#303030' }}>{formatAmount(item)}</TableCell>
                  <TableCell align="center" sx={{ color: '#303030' }}>{item.reasonCode || '-'}</TableCell>
                  <TableCell align="center" sx={{ color: '#303030' }}>{formatDate(item.dueDateForNetPayment)}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </Box>
      </DialogContent>
      <DialogActions sx={{ gap: '10px', padding: '36px 24px 16px' }}>
        <Button startIcon={<ArrowBackIcon />} onClick={onBack} variant="outlined" sx={{ borderColor: '#75a16d', color: '#367c2b', fontWeight: 600, minWidth: '122px', '&:hover': { borderColor: '#367c2b', backgroundColor: 'transparent' } }}>Cancel</Button>
        <Button endIcon={<ArrowForwardIcon />} onClick={handleNext} variant="contained" sx={{ backgroundColor: '#ffd800', color: '#000', fontWeight: 600, minWidth: '112px', '&:hover': { backgroundColor: '#e6c200' } }}>
          Next
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default LineItemSelectionModal;